const baseColors = {
    black: {
        5: '#F2F2F2',
        10: '#E5E5E5',
        20: '#CCCCCC',
        30: '#B3B3B3',
        40: '#979797',
        60: '#5B5B5B',
        80: '#333333',
        100: '#000000'
    },
    blue: {
        10: '#E5F4FC',
        100: '#008EDE',
        120: '#0072B2'
    },
    electricBlue: {
        10: '#F2FBFF',
        40: '#CDF1FE',
        80: '#9BE3FD',
        100: '#2DC5FA',
        120: '#249EC8',
        140: '#1B7696',
        160: '#124F64'
    },
    green: {
        10: '#E7F9ED',
        100: '#11BE4C',
        120: '#0E983D'
    },
    oceanBlue: {
        10: '#EBEDFE',
        40: '#AEB7F9',
        70: '#4C53F1',
        80: '#5D6FF4',
        100: '#3800EB',
        120: '#2D00BC',
        140: '#1F2D91',
        160: '#16005E'
    },
    orange: {
        10: '#FEF6E9',
        100: '#F8A324',
        130: '#AE7219'
    },
    pink: {
        10: '#FDE6F0',
        40: '#FEA7CF',
        80: '#F16BA7',
        100: '#EC398A',
        120: '#B90657',
        140: '#8B0541',
        160: '#5C032C'
    },
    purple: {
        10: '#F5E8FE',
        40: '#EBD0FC',
        80: '#C273F6',
        100: '#9A16F0',
        120: '#7B12C0',
        140: '#5C0D90',
        160: '#3E0960'
    },
    red: {
        10: '#FDEDED',
        100: '#EB4C4C',
        120: '#BC3D3D'
    },
    turquoise: {
        10: '#D5F5F3',
        40: '#AAECE8',
        80: '#6BDDD6',
        100: '#2BCFC5',
        120: '#22A59E',
        140: '#1A7C76',
        160: '#11534F'
    },
    white: {
        100: '#FFFFFF'
    },
    yellow: {
        10: '#FFFEEB',
        40: '#FEFBC2',
        80: '#FCF785',
        90: '#C9FF58',
        100: '#FAF234',
        120: '#D7CE06',
        140: '#ACA502',
        160: '#837E02'
    }
};
export const gradients = {
    ai: 'linear-gradient(105deg, #6BDDD6 27.18%, #4C53F1 100%)',
    brand: 'linear-gradient(114.99deg, #344BF1 24.14%, #2DC5FA 105.44%)',
    cyber: 'linear-gradient(287.72deg, #F9E450 0%, #2BCFC5 87.67%)',
    data: 'linear-gradient(284.43deg, #FAF234 0%, #EC398A 96.5%)',
    dv: 'linear-gradient(288deg, #2DC5FA 0%, #F16BA7 87.67%);',
    interactive: 'linear-gradient(90.68deg, #3800EB -7.48%, #9A16F0 113.27%)',
    mk: 'linear-gradient(288deg, #F16BA7 0%, #3800EB 87.67%)',
    ml: 'linear-gradient(288deg, #2EC6FB 0%, #D6A2F9 87.67%)',
    ux: 'linear-gradient(104.9deg, #EC398A 27.18%, #9A16F0 100%)',
    web: 'linear-gradient(107.05deg, #9A16F0 17.93%, #2DC5FA 92.3%)'
};
export default {
    ...baseColors,
    background: {
        ai: gradients.ai,
        brand: gradients.brand,
        cloud: baseColors.blue[10],
        cyber: gradients.cyber,
        dark: baseColors.oceanBlue[160],
        data: gradients.data,
        dv: gradients.dv,
        light: baseColors.black[5],
        'light-cyber': baseColors.green[10],
        'light-data': baseColors.orange[10],
        'light-ux': baseColors.pink[10],
        'light-web': baseColors.oceanBlue[10],
        mk: gradients.mk,
        ml: gradients.ml,
        ux: gradients.ux,
        web: gradients.web,
        white: baseColors.white[100]
    },
    brand: {
        primary: baseColors.electricBlue[100],
        secondary: baseColors.oceanBlue[100]
    },
    button: {
        disabled: baseColors.black[30],
        facebook: {
            enabled: baseColors.oceanBlue[100],
            hover: baseColors.oceanBlue[140],
            pressed: baseColors.purple[160]
        },
        google: {
            enabled: baseColors.white[100],
            hover: baseColors.black[10],
            pressed: baseColors.black[20]
        },
        primary: {
            enabled: gradients.interactive,
            hover: `linear-gradient(${baseColors.oceanBlue[100]}, ${baseColors.oceanBlue[100]})`,
            pressed: baseColors.oceanBlue[140]
        },
        secondary: {
            enabled: baseColors.white[100],
            hover: baseColors.purple[100],
            pressed: baseColors.purple[140]
        },
        tertiary: {
            enabled: baseColors.purple[100],
            hover: baseColors.oceanBlue[100],
            pressed: baseColors.purple[160]
        }
    },
    fill: {
        black: baseColors.black[100],
        footer: baseColors.oceanBlue[160],
        interactive: baseColors.purple[100],
        light: baseColors.black[10],
        medium: baseColors.black[40],
        new: baseColors.pink[100],
        preFooter: baseColors.oceanBlue[140],
        primary: baseColors.electricBlue[100],
        secondary: baseColors.oceanBlue[100],
        translucid: `${baseColors.black[100]}99`,
        white: baseColors.white[100],
        yellow: baseColors.yellow[90]
    },
    gradient: {
        ai: {
            0: baseColors.turquoise[80],
            1: baseColors.oceanBlue[70]
        },
        brand: {
            0: '#344BF1',
            1: baseColors.electricBlue[100]
        },
        cyber: {
            0: '#F9E450',
            1: baseColors.turquoise[100]
        },
        data: {
            0: baseColors.yellow[100],
            1: baseColors.pink[100]
        },
        dv: {
            0: baseColors.electricBlue[100],
            1: baseColors.pink[80]
        },
        interactive: {
            0: baseColors.oceanBlue[100],
            1: baseColors.purple[100]
        },
        mk: {
            0: baseColors.pink[80],
            1: baseColors.oceanBlue[100]
        },
        ml: {
            0: '#2EC6FB',
            1: '#D6A2F9'
        },
        ux: {
            0: baseColors.pink[100],
            1: baseColors.purple[100]
        },
        web: {
            0: baseColors.purple[100],
            1: baseColors.electricBlue[100]
        }
    },
    icon: {
        dark: baseColors.black[100],
        error: baseColors.red[100],
        info: baseColors.blue[100],
        new: baseColors.purple[100],
        primary: baseColors.electricBlue[100],
        secondary: baseColors.oceanBlue[100],
        success: baseColors.green[100],
        warning: baseColors.orange[100]
    },
    link: {
        link: baseColors.purple[100],
        hover: baseColors.oceanBlue[100],
        pressed: baseColors.purple[140],
        disabled: baseColors.black[30],
        inverse: baseColors.white[100]
    },
    stroke: {
        dark: baseColors.black[100],
        error: baseColors.red[100],
        info: baseColors.blue[100],
        interactive: baseColors.purple[100],
        light: baseColors.black[30],
        medium: baseColors.black[40],
        success: baseColors.green[100],
        warning: baseColors.orange[100],
        white: baseColors.white[100]
    },
    support: {
        error: {
            icon: baseColors.red[100],
            background: baseColors.red[10],
            text: baseColors.red[120]
        },
        info: {
            icon: baseColors.blue[100],
            background: baseColors.blue[10],
            text: baseColors.blue[120]
        },
        success: {
            icon: baseColors.green[100],
            background: baseColors.green[10],
            text: baseColors.green[120]
        },
        warning: {
            icon: baseColors.orange[100],
            background: baseColors.orange[10],
            text: baseColors.orange[130]
        }
    },
    text: {
        inverse: baseColors.white[100],
        primary: baseColors.black[100],
        secondary: baseColors.black[60],
        tertiary: baseColors.black[40]
    }
};

//# sourceMappingURL=color.js.map